import { jsx } from '@emotion/react';
import { Icon } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { Button } from 'react-aria-components';
import { createUniqueClassName } from '../../../utils/createUniqueClassName';
import { UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH } from '../../../../universal-nav/constants';
import { interactiveReset } from '../../../../utils/style-mixins/reset';
const tooltipClassName = createUniqueClassName('MoreButton', 'tooltip');
const tooltipSelector = `.${tooltipClassName}`;
const navIconClassName = createUniqueClassName('MoreButton', 'navIcon');
const navIconSelector = `.${navIconClassName}`;
const Styles = labelStyles('MoreButton', {
    root: () => [
        Object.assign(Object.assign({}, interactiveReset), { font: `var(--zds-body-1)`, color: 'var(--zds-text-default, #413735)', display: 'flex', position: 'relative', minHeight: 'var(--zds-size-36, 36px)', padding: 'var(--zds-space-0, 0px) var(--zds-space-8, 8px)', borderRadius: 4, whiteSpace: 'nowrap', width: '100%', transition: `0s`, textDecoration: 'none', outline: 'solid 2px transparent', '&::before': {
                content: '""',
                position: 'absolute',
                pointerEvents: 'none',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                border: '2px solid transparent',
                borderRadius: 4,
            }, '&:focus': {
                backgroundColor: 'var(--zds-background-weaker, #FFFDF9)',
            }, '&:hover': {
                transition: 'none',
                backgroundColor: 'var(--zds-background-stronger, #F5F3EB)',
                outline: `solid 2px transparent`,
            }, '&:focus-visible': {
                '&::before': {
                    border: 'var(--zds-border-focus, 2px solid #695BE8)',
                    top: '-2px',
                    right: '-2px',
                    bottom: '-2px',
                    left: '-2px',
                },
            }, [navIconSelector]: {
                color: 'var(--zds-text-default, #413735)',
            }, [`&:hover ${navIconSelector}, &:focus ${navIconSelector}`]: {
                transition: 'none',
            }, [`@container (max-width: ${UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH}px)`]: {
                width: 'var(--zds-space-36, 36px)',
                [`${tooltipClassName}`]: {
                    display: 'none',
                },
            } }),
        {
            [tooltipSelector]: {
                opacity: 0,
                pointerEvents: 'none',
                transition: 'opacity 0.1s ease-in-out',
                '@media (hover: none)': {
                    display: 'none',
                },
            },
            [`&:hover ${tooltipSelector}, &:focus ${tooltipSelector}`]: {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
    ],
    layout: {
        display: 'flex',
        gap: 'var(--zds-space-12, 12px)',
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
    },
    text: {
        '&[aria-hidden="true"]': {
            opacity: 0,
        },
    },
});
const MoreButton = ({ text, icon, isCollapsed = false, onClick: onClickProp = undefined, renderBeforeText = (props) => props.icon && (jsx("span", { className: navIconClassName },
    jsx(Icon, { isBlock: true, name: props.icon, size: 20 }))), }) => {
    const props = {
        text,
        icon,
        isCollapsed,
        onClick: onClickProp,
        renderBeforeText,
    };
    const onClick = (e) => {
        e.target.blur();
        if (onClickProp) {
            onClickProp(e);
        }
    };
    const beforeText = renderBeforeText && renderBeforeText(props);
    return (jsx(Button, { css: Styles.root(null, !!beforeText), "data-zds": true, onPress: onClick, id: "sidebar-more-button" },
        jsx("span", { css: Styles.layout, "data-zds": true },
            beforeText,
            jsx("span", { css: Styles.text, "data-zds": true }, text))));
};
export default MoreButton;
//# sourceMappingURL=MoreButton.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
